<template>
  <div>
    <v-toolbar
      color="pageHeader"
      height="32"
      flat
      tile
      dark
      style="padding-left: 20px"
    >
      <v-icon left> mdi-label-variant </v-icon
      >{{ $t("dashboard.lblStrategyOverview") }}
   
    </v-toolbar>

   <!--  <v-row>
      <v-col cols="12" sm="12" md="12" style="border: 1px solid lightgray"> -->
        <v-card color="Neutral">
          <v-list color="primaryLight1" flat tile style="padding:0px;">
            <v-list-item>
              <!--  <v-list-item-avatar>
          <v-img src="https://cdn.vuetifyjs.com/images/john.png"></v-img>
        </v-list-item-avatar> -->
              <v-list-item-content>
                <v-list-item-title><h3>{{ $t("dashboard.tOurVision") }}</h3></v-list-item-title>
                <v-list-item-subtitle
                  >{{ $t("dashboard.subtOurVision") }}</v-list-item-subtitle
                >
              </v-list-item-content>
              <v-list-item-action>
                <v-switch v-model="cycle" color="pageHeader" :label="$t('dashboard.slideShow')" inset></v-switch>
              </v-list-item-action>
            </v-list-item>
          </v-list>
        <!--   <v-card-title>Our Vision: BE GLOBAL</v-card-title>
          <v-card-subtitle
            >Establish a world class software company by 2027</v-card-subtitle
          > -->
          <v-card-text>
            <v-carousel
              :cycle="cycle"
              show-arrows-on-hover
              hide-delimiter-background
              color="error"
              interval="10000"            
            >
              <v-carousel-item>
                <v-card class="mx-auto" elevation="5" max-width="70%">
                  <v-img :src="visionImage"> </v-img>
                </v-card>
              </v-carousel-item>
              <v-carousel-item
                ><v-card class="mx-auto" elevation="5" max-width="70%">
                  <v-img :src="missionImage"> </v-img>
                </v-card>
              </v-carousel-item>
            </v-carousel>
          </v-card-text>
        </v-card>
      <!-- </v-col>
    </v-row> -->
  </div>
</template>
<style  scoped>

::v-deep .v-image {
    z-index: 0;
  height: 100% !important;
}

::v-deep .v-carousel {
    overflow: hidden;
    position: relative;
    width: 100%;
    height: 100% !important;
    min-height: 500px!important;
}
</style>
<script>

export default {
  name: "VisionStatementSlider",
  data() {
    return {
        cycle:false,
      visionImage: require("@/assets/images/MissionStatementN11.png"),
      missionImage: require("@/assets/images/MissionStatementN22.png"),
    };
  },
};
</script>